(ns humbleai.belt.core
  (:require [meta-merge.core :as meta-merge])
  #?(:clj (:import [java.util Optional]
                   [java.lang ScopedValue])))

(def meta-merge meta-merge/meta-merge)

(defn qualified-name
  "Like `clojure.core/name` but preserves the namespace of <x>.
   For keywords, essentially the same as `(subs (name x) 1)`."
  [x]
  (let [name* (name x)]
    (if-some [ns (when-not (string? x) (namespace x))]
      (str ns \/ name*)
      name*)))

#?(:cljs (defn transient? [x] (satisfies? ITransientCollection x))
   :clj  (def transient?  (partial instance? clojure.lang.IEditableCollection)))

#?(:cljs (def re-pattern? (partial instance? js/RegExp))
   :clj  (def re-pattern? (partial instance? java.util.regex.Pattern)))

#?(:cljs (def throwable?  (partial instance? js/Error))
   :clj  (def throwable?  (partial instance? Throwable)))

#?(:clj
   (defn deref++
     "A more inclusive version of `clojure.core/deref`."
     ([x]
      (condp instance? x
        Optional     (when (.isPresent ^Optional x)  (.get ^Optional x))    ;; https://clojure.atlassian.net/browse/CLJ-2905
        ScopedValue  (when (.isBound ^ScopedValue x) (.get ^ScopedValue x)) ;; https://clojure.atlassian.net/browse/CLJ-2926
        ;LazyConstant (.get ^LazyConstant x) ;; wait for it
        (deref x)))
     ([x timeout-ms timeout-val]
      (deref x timeout-ms timeout-val))))
